<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="800px" transition="dialog-transition">
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <v-toolbar-title>Datos de Factura Electronica</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="py-2" v-if="factura && matriz" id="factura_html">
          <!-- <embed v-if="base64" :src="base64" width="100%" height="100%" /> -->
          <!-- <iframe v-if="base64" :src="base64" width="100%" height="900px" /> -->
          <object v-if="base64" :data="base64" width="100%" height="950px" />
        </v-card-text>
        <v-divider class="my-0"></v-divider>
        <v-progress-linear v-if="cargandopdf" indeterminate />

        <div v-if="factura" class="text-center my-4">
          <p class="text-center ma-0">
            <small
              ><b>Factura emitida en modo: </b> <span> {{ getTipoEmision(factura.tipoEmision) }} </span></small
            >
          </p>
          <a :href="factura.qr" target="_blank"> Click aqui para ver en <b>SIAT</b> </a>
        </div>
        <v-card-actions v-if="factura && matriz">
          <a
            :download="'Factura-' + factura.nombreRazonSocial"
            v-if="$store.state.CARGO.id!=27"
            :href="base64"
            color="primary"
            class="btn"
            :disabled="cargandopdf"
            small
            rounded
            title="Descargar"
          >
            <v-icon class="mr-1"> mdi-printer</v-icon>
            Descargar
          </a>

          <v-btn color="red" dark v-if="puedeAnular" small rounded @click="abrirAnularFactura()">
            <v-icon class="mr-1"> mdi-file-cancel</v-icon> Anular Factura
          </v-btn>
          <v-btn
            v-if="($store.state.CARGO.id == 1 || $store.state.CARGO.id == 14) && isAnulada"
            color="red"
            dark
            small
            rounded
            @click="anularFacturaDeRecibo()"
          >
            <v-icon class="mr-1"> mdi-cancel</v-icon> Eliminar Factura de Recibo
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" outlined small rounded @click="closeDialog">
            Cerrar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-skeleton-loader v-else transition="scale-transition" height="290" type="table"> </v-skeleton-loader>
      </v-card>
    </v-dialog>

    <Anular ref="anularfactura" v-on:anuladofact="anuladofact" />
  </v-row>
</template>

<script>
  // https://www.learmoreseekmore.com/2020/10/vuejs-vueqrcode.html
  //import VueQrcode from 'vue-qrcode';
  import Anular from '@/views/recibos/AnularFE.vue';
  import xaxios from '@/xaxios';
  import axios from 'axios';
  import gql from 'graphql-tag';
  import moment from 'moment';
  import numeral from 'numeral';
  import { mapState } from 'vuex';
  import { getAccessToken } from '@/accessToken';

  moment.locale('es');

  export default {
    components: { Anular },
    props: ['programa_id'],
    data() {
      return {
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        cssText: null,
        cargandopdf: false,
        base64: null,

        size: 1.6,
        level: 'H',
        dialog: false,
        recibo: null,
        factura: null,
        subtotal: 0.0,
        programa: {},
        today: new Date().toISOString(),
        matriz: null,
        sucursal: null,
        nit: null,
        literal: null,
        estado: true,
        isAnulada: false,
        apikeytoken: '',
      };
    },
    computed: {
      puedeAnular() {
        if (!this.factura) return false;
        if (this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14) {
          let fs = this.factura.fechaEmision;
          try {
            //22/06/2022 07:58:02 AM
            let d = fs.substring(0, 2);
            let m = fs.substring(3, 5);
            let a = fs.substring(6, 10);
            let inicio = new Date();
            inicio.setMonth(parseInt(m) - 1);
            inicio.setDate(parseInt(d));
            inicio.setFullYear(parseInt(a));
            let fin = new Date();
            // fin.setDate(-4); // en realidad resta -34 dias, no se porque
            fin.setDate(-34); // ahora(en diciembre) se tuvo que restar -34 dias, y no se porque
            let dx = inicio.getTime() > fin.getTime();
            window.console.log('>>>', fs, inicio, fin, dx);

            //window.console.log(':::>>>', fechita, inicio, fin, dx);
            return true;
          } catch (e) {
            window.console.error(e);
            return false;
          }
        }
        return false;
      },
      ...mapState({
        sede_id: (state) => state.CARGO.sede.id,
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      }),
    },
    watch: {
      programa_id(id) {
        if (id)
        xaxios.get(`${this.api_rest}/esam/programa/id/${id}`).then(({ data }) => {
            this.programa = data;
          });
      },
    },
    methods: {
      async showThisView(factura_id, recibo, facturaelectro, cargautil, nitapikey) {
        window.console.log('facturaelectro>>>', facturaelectro);
        window.console.log('recibolectro>>>', recibo);
        window.console.log('factura_id>>>', factura_id);
        window.console.log('cargautil>>>', cargautil);
        window.console.log('nitapikey>>>', nitapikey);

        this.apikeytoken = nitapikey;
        this.dialog = true;
        this.base64 = null;
        this.recibo = recibo;
        if (facturaelectro) {
          /*facturaelectro.map((x) => {
            x.venta.nombreRazonSocial = x.venta.nombreRazonSocial + ''.toUpperCase();
          });*/
          //this.base64 = 'data:application/pdf;base64,' + facturaelectro.camposEspecificos.pdf + '#toolbar=0';
          this.base64 = 'data:application/pdf;base64,' + facturaelectro.facturaBase64 + '#toolbar=0';
          this.factura = facturaelectro.venta;
          this.factura.codigoPuntoVenta = cargautil.codigoPuntoVenta;

          this.completardatos();
          this.factura.detalle = recibo.detalle;
        } else {
          this.factura = this.getFacturaData(factura_id, recibo);
        }
      },
      async completardatos() {
        const writtenNumber = require('written-number');
        //this.factura.qr = `https://siat.impuestos.gob.bo/consulta/QR?nit=${this.factura.nit}&cuf=${this.factura.cuf}&numero=${this.factura.numeroFactura}&t=2`;
        // this.factura.qr = `${process.env.VUE_APP_FACT_QR_SIN}/QR?nit=${this.factura.nit}&cuf=${this.factura.cuf}&numero=${this.factura.numeroFactura}&t=2`;
        this.factura.qr = this.factura.urlSiat;
        this.literal = writtenNumber(this.factura.montoTotal, { lang: 'es' });
        //let nits = await this.getNits();
        this.parsexml(this.factura.factura); // ya no se usa ? 
        //this.getSucursales(this.factura.nit, nits, this.factura.idSucursal);
      },
      getSucursales(nro_nit, nits, sucursal_id) {
        const qs = gql`query{ ${''} getSucursales{ id,nit_id,direccion,telefono,ciudad,numero_sucursal } }`;
        this.$apollo.query({ query: qs }).then(({ data }) => {
          let sucursales = data.getSucursales ? data.getSucursales : [];
          //window.console.log('>>>: ', sucursales);
          if (data.getSucursales.length) {
            this.nit = nits.find((ni) => ni.nro == nro_nit);
            sucursales = sucursales.filter((s) => s.nit_id === this.nit.id);
            this.matriz = sucursales.find((s) => s.numero_sucursal === 0);
            this.sucursal = sucursales.find((s) => s.id === sucursal_id);
            let xml = this.parsexml(this.factura.factura);
            let num_suc = this.parsexmlvalue(xml, 'codigoSucursal');
            let razonSocialEmisor = this.parsexmlvalue(xml, 'razonSocialEmisor');
            let direccion = this.parsexmlvalue(xml, 'direccion');
            let codigoPuntoVenta = this.parsexmlvalue(xml, 'codigoPuntoVenta');

            if (num_suc) this.matriz.numero_sucursal = num_suc;
            if (razonSocialEmisor) this.nit.nombre = razonSocialEmisor;
            if (direccion) this.matriz.direccion = direccion;
            if (!codigoPuntoVenta) codigoPuntoVenta = '0';
            this.factura.codigoPuntoVenta = codigoPuntoVenta;
          }
        });
      },
      getNits() {
        const qs = gql`query{ ${''} getNits{ id, nombre, descripcion, nro, estado }}`;
        return this.$apollo.query({ query: qs }).then(({ data }) => (data.getNits ? data.getNits : []));
      },
      getTipoEmision(tipo) {
        if (tipo == 1) return 'Online';
        else return 'Offline';
      },

      parsefechaint(fecha) {
        let fs = '' + fecha;
        let a = fs.substring(0, 4);
        let m = fs.substring(4, 6);
        let d = fs.substring(6, 8);
        let hh = fs.substring(8, 10);
        let mm = fs.substring(10, 12);

        //window.console.log('fecha::::', d, m, a, hh, mm);
        this.factura.fecha_registro = '';
        return `${d}/${m}/${a} ${hh}:${mm}`;
      },

      getFacturaData(factura_id, recibo) {
        window.console.log('recibolectro>>>', recibo);
        window.console.log('/*/factura_id>>>', factura_id);
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/${factura_id}`,
          headers: {
            'Content-Type': 'application/json',
            // apikey: this.$store.getters.getApiKey,
            apikey: this.apikeytoken,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('getFacturaData:::: ', data);
            vue.factura = data.venta; // sedes dbs 
            if(!vue.factura) vue.factura = data.Venta; // sedes esam
            vue.factura.detalle = recibo.detalle;
            vue.base64 = 'data:application/pdf;base64,' + data.facturaDocumento + '#toolbar=0';
            vue.completardatos();
            vue.isAnulada = vue.factura.estado == 'ANULACION CONFIRMADA';
          })
          .catch(function(error) {
            window.console.log('error ongetFacturaData:', error);
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data, mensaje);
            vue.$root.$notify.show(mensaje, { color: 'red' });
            vue.$emit('noFoundElectronica', factura_id);
            vue.dialog = false;
          });
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.slice(0, 10).split('-');
        return `${day}/${month}/${year}`;
      },
      async anularFactura() {
        //window.console.log('PUEDE>>> ', this.puedeAnular);
        if (this.puedeAnular) {
          //if (this.factura.fecha_registro.substr(0, 7) === this.today.substr(0, 7)) {
          if (
            await this.$root.$confirm.open(
              'Anular Factura',
              '<strong> Esta accion es irreversible. <br /> Estas seguro?</strong> ',
              { color: 'red' },
            )
          ) {
            xaxios.delete(`${this.api_rest}/api/pagos/factura/id/${this.factura.id}`).then((res) => {
              this.$root.$notify.show(res.status === 200 ? 'Factura Anulada' : 'No se puede anular la Factura', {
                color: 'info',
              });
              this.$emit('fanulada');
            });
            this.closeDialog();
          }
        }
      },
      numeralFormat(value) {
        return numeral(value).format('0,0.00');
      },

      descargarpdf() {},

      sendcorreo(sendemail) {
        this.cargandopdf = true;
        if (sendemail) this.crearpdfbase64();
        else this.crearpdf();
      },

      crearpdf() {
        let vue = this;
        let elementoParaConvertir = window.$('#factura_html').html();
        window
          .html2pdf()
          .set({
            margin: 0.5,
            filename: `Factura Electronica`,
            image: {
              type: 'jpeg',
              quality: 0.9,
            },
            html2canvas: {
              dpi: 192,
              scale: 3,
              letterRendering: true,
            },
            pagebreak: { mode: 'avoid-all' } /*corrige el salto de pagina*/,
            jsPDF: {
              unit: 'in',
              format: 'letter',
              orientation: 'portrait',
            },
          })
          .from(elementoParaConvertir)
          .toPdf()
          .output('datauristring')
          .then(function() {
            vue.cargandopdf = false;
          })
          .save()
          .catch((err) => {
            window.console.log(err);
            vue.cargandopdf = false;
          });
      },

      crearpdfbase64() {
        let vue = this;
        let elementoParaConvertir = window.$('#factura_html').html();
        window
          .html2pdf()
          .set({
            margin: 0.5,
            filename: `Factura Electronica`,
            image: {
              type: 'jpeg',
              quality: 0.9,
            },
            html2canvas: {
              dpi: 192,
              scale: 3,
              letterRendering: true,
            },
            pagebreak: { mode: 'avoid-all' } /*corrige el salto de pagina*/,
            jsPDF: {
              unit: 'in',
              format: 'letter',
              orientation: 'portrait',
            },
          })
          .from(elementoParaConvertir)
          .toPdf()
          .output('datauristring')
          .then(function(pdfObj) {
            // quitamos: data:application/pdf;base64,
            let base64 = pdfObj.substring(28);
            //window.console.log('pdfObj::::', base64);
            vue.enviarCorreoBackend(base64);
            //vue.cargandopdf = false;
          })
          //.save()
          .catch((err) => {
            window.console.log(err);
            vue.cargandopdf = false;
          });
      },

      cortarCuf(cuf) {
        let tam = cuf.length / 2;
        let a = cuf.substring(0, tam);
        let b = cuf.substring(tam);
        return `${a} ${b}`;
      },

      abrirAnularFactura() {
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if(unidad==2){
          let userid = this.$store.state.DATA_USER.id;
          let cargoid = this.$store.state.CARGO.id;
          let userperm = userid == 18491 || userid == 870 || userid == 54960 || cargoid == 1 || userid == 52394;
          if( !userperm ){ // nicole andrade, nataly soruco 
            this.$root.$notify.show(`No tiene autorizacion para esta accion`, {color:'danger',x: 'left',});
            return;
          }
        }
        this.$refs.anularfactura.openmodal(this.factura);
      },
      anuladofact() {
        this.dialog = false;
        this.recibo.factura_id = null;
        this.$emit('anuladofact', this.recibo);
      },

      closeDialog() {
        this.dialog = false;
        this.recibo = null;
        this.matriz = null;
        this.sucursal = null;
        this.factura = null;
        this.nit = null;
        this.subtotal = 0.0;
        this.form = { nombre_cliente: null, nit_cliente: null, sucursal_id: null };
      },

      parsexmlvalue(xmlDoc, key) {
        try {
          return xmlDoc.getElementsByTagName(key)[0].childNodes[0].nodeValue;
        } catch (e) {
          return '';
        }
      },

      parsexml(factura) {
        this.nit = {};
        this.matriz = {};
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(factura, 'text/xml');
        this.matriz.direccion = this.parsexmlvalue(xmlDoc, 'direccion');
        this.nit.ciudad = this.parsexmlvalue(xmlDoc, 'municipio');
        this.matriz.numero_sucursal = this.parsexmlvalue(xmlDoc, 'codigoSucursal');
        let pv = this.parsexmlvalue(xmlDoc, 'codigoPuntoVenta');
        if (pv) this.factura.codigoPuntoVenta = pv;
        else this.factura.codigoPuntoVenta = 0;
        this.factura.detalle = [];
        let vue = this;

        let item = {};
        let i = 0;
        let x = xmlDoc.getElementsByTagName('detalle');

        let arr = Array.prototype.slice.call(x);
        while (item && i < 100) {
          item = x[i];
          if (arr[i]) {
            let arr2 = Array.prototype.slice.call(arr[i].children);

            let deta = {
              concepto_pago_id: arr2[2].innerHTML,
              cantidad: arr2[4].innerHTML,
              unidad_medida_abreviatura: arr2[5].innerHTML,
              concepto: arr2[3].innerHTML,
              monto: arr2[6].innerHTML,
            };
            vue.factura.detalle.push(deta);
          }
          i = i + 1;
        }

        window.console.log('\n\n>>>', x, typeof x);
      },

      enviarCorreoBackend(base64) {
        let vue = this;
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/email`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          data: {
            facturaBase64: base64,
            facturaID: this.factura.id,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('correo:', data);
            vue.cargandopdf = false;
            vue.$root.$notify.show(data, { color: 'success', x: 'left' });
          })
          .catch(function(error) {
            window.console.log(error.response);
            vue.cargandopdf = false;
            vue.$root.$notify.show(`No se pudo enviar por correo, pruebe descargar y enviarlo manualmente.`, {
              color: 'red',
              x: 'left',
            });
          });
      },
      anularFacturaDeRecibo() {
        const vue = this;
        var config = {
          method: 'put',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/recibo/addfactura`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            recibo_id: this.recibo.id,
            factura_id: null,
            numero_factura: null,
            nit: null,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('anularFacturaDeRecibo: ', data);
            vue.$root.$notify.show('Ahora puedes volver a generar la factura o eliminar el recibo.', {
              color: 'info',
            });
            vue.dialog = false;
            vue.recibo.factura_id = null;
            vue.$emit('anuladofact', vue.recibo);
          })
          .catch(function(error) {
            let data = error.response;
            window.console.log(data);
          });
      },
      async obtenerToknFactura(idsuc) {
        // let idsuc = this.$route.query.idsucursal;
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
    },
    mounted() {
      const [day, month, year] = new Date()
        .toLocaleString('es-US', {
          timeZone: 'America/La_Paz',
          year: 'numeric',
          day: '2-digit',
          month: '2-digit',
        })
        .split('/');
      this.today = `${year}-${month}-${day}`;
      // window.console.log('variable', this.today, this.today.substr(0, 7));
      this.cssText = `
      table {
    border-collapse: collapse;
    border-spacing: 0;
    font-size: x-small;
    width: 100%;
  }
  table tbody td:first-child{
    background: transparent!important;
  }
  .tablae tr,
  .tablae td {
    border: 1px solid #999;
  }
  .trclean {
    border-left: 1px solid white !important;
    border-top: 1px solid white !important;
    border-bottom: 1px solid white !important;
  }
  .table-border {
    border: 1px solid silver;
  }
  .w-35per {
    width: 35%;
  }
  .w-98per {
    width: 98%;
  }
  .w-38per {
    width: 38%;
  }
  .w-40per {
    width: 40%;
  }
  .w-20per {
    width: 20%;
  }
  .w-24per {
    width: 24%;
  }
  .w-23per {
    width: 23%;
  }
  .w-10per {
    width: 10%;
  }
  .x-small {
    font-size: x-small;
  }
  .text-center {
    text-align: center;
  }
  .align-v-center {
    vertical-align: center;
  }
  .font-weight-bold {
    font-weight: bold;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .w-100 {
    width: 100%;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .mb-3 {
    margin-bottom: 1rem;
  }
  .mb-2 {
    margin-bottom: 0.7rem;
  }
  .item-th {
    font-weight: bold;
    align-items: left;
  }
  hr {
    margin-bottom: 3rem;
    margin-top: 3rem;
  }
  .float-left {
    float: left !important;
  }
  .border-box {
    border: solid 1px #4d84c7c7;
    border-radius: 0.4em;
    box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.3);
  }
  .recibo-number {
    font-weight: bold;
    color: #305077;
    /* font-size: 1.2rem; */
  }
  .img-height {
    height: 60px;
  }
  .px-2 {
    padding-left: 2em;
    padding-right: 2em;
  }
  .pa-2 {
    padding: 2em;
  }
  .mitad-solid {
    position: absolute;
    top: 50%;
  }
  .font-size-1 {
    font-size: 1rem;
  }
  .pl-1 {
    padding-left: 0.5em;
  }
  .watermark1 {
      width: 40%;
      position: absolute;
      top: 10%;
      left: 30%;
  }
  .watermark3 {
      width: 40%;
      position: absolute;
      top: 35%;
      left: 30%;
  }
  .watermark2 {
      width: 30%;
      position: absolute;
      top: 0px;
      right: 2px;
      opacity: 70%;
  }
    `;
    },
  };
  // DELETE FROM detalle_factura WHERE factura_id >5;
  // UPDATE pagos_inscripcion SET factura_id = null WHERE factura_id >5;
  // DELETE FROM facturas WHERE id >5;
</script>

<style scoped>
  table {
    border-collapse: collapse;
    border-spacing: 0;
    font-size: x-small;
    width: 100%;
  }
  table tbody td:first-child {
    background: transparent !important;
  }
  table tbody td {
    color: black !important;
  }
  .text-left {
    text-align: left;
  }
  .tablae {
    color: #000;
  }
  .tablae tr,
  .tablae td {
    border: 1px solid #999;
  }
  .trclean {
    border-left: 1px solid white !important;
    border-top: 1px solid white !important;
    border-bottom: 1px solid white !important;
  }
  .table-border {
    border: 1px solid silver;
  }
  .w-35per {
    width: 35%;
  }
  .w-98per {
    width: 98%;
  }
  .w-38per {
    width: 38%;
  }
  .w-40per {
    width: 40%;
  }
  .w-20per {
    width: 20%;
  }
  .w-24per {
    width: 24%;
  }
  .w-23per {
    width: 23%;
  }
  .w-10per {
    width: 10%;
  }
  .x-small {
    font-size: x-small;
  }
  .text-center {
    text-align: center;
  }
  .align-v-center {
    vertical-align: center;
  }
  .font-weight-bold {
    font-weight: bold;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .w-100 {
    width: 100%;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .mb-3 {
    margin-bottom: 1rem;
  }
  .mb-2 {
    margin-bottom: 0.7rem;
  }
  .item-th {
    font-weight: bold;
    align-items: left;
  }
  hr {
    margin-bottom: 3rem;
    margin-top: 3rem;
  }
  .float-left {
    float: left !important;
  }
  .border-box {
    border: solid 1px #4d84c7c7;
    border-radius: 0.4em;
    box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.3);
  }
  .recibo-number {
    font-weight: bold;
    color: #305077;
    /* font-size: 1.2rem; */
  }
  .img-height {
    height: 60px;
  }
  .px-2 {
    padding-left: 2em;
    padding-right: 2em;
  }
  .pa-2 {
    padding: 2em;
  }
  .pl-1 {
    padding-left: 0.5em;
  }
  .mitad-solid {
    position: absolute;
    top: 50%;
  }
  .font-size-1 {
    font-size: 1rem;
  }
  .watermark1 {
    width: 50%;
    position: absolute;
    top: 30%;
    left: 25%;
  }
  .watermark2 {
    display: none;
  }
</style>
